import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
export function HomeFAQActions() {
  return <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1658">
      <Link to="/summer-camp" className="btn-primary" data-id="element-1659">
        Ask About Summer Camp
      </Link>
      <a href="tel:517-220-0621" className="btn-secondary" data-id="element-1660">
        <Phone className="w-5 h-5 mr-2" data-id="element-1661" />
        Call Storm
      </a>
    </div>;
}